export default "__VITE_ASSET__e81a7cda__"